import '@total-typescript/ts-reset';

const hexToRgb = (hex) => {
  const result = hex.length === 4 ? /^#?([\da-f])([\da-f])([\da-f])$/i.exec(hex) : /^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i.exec(hex);
  if (!result) {
    throw new Error(`Wrong HEX color value: ${hex}. Cannot convert HEX to RGB`);
  }
  const red = Number.parseInt(result[1], 16);
  const green = Number.parseInt(result[2], 16);
  const blue = Number.parseInt(result[3], 16);
  return `${red} ${green} ${blue}`;
};

const removeGeneratedIds = (fragment) => {
  if (!fragment.firstElementChild) return fragment;
  const headlessUiGeneratedIdRegex = /-:(\w|\d)+:/g;
  const html = fragment.firstElementChild.innerHTML.replaceAll(
    headlessUiGeneratedIdRegex,
    ""
  );
  fragment.firstElementChild.innerHTML = html;
  return fragment;
};

const setParam = (name, value) => {
  const currentUrl = new URL(window.location.href);
  const params = new URLSearchParams(currentUrl.search);
  params.set(name, value);
  const searchString = [...params.entries()].map(
    ([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`
  ).join("&");
  return `${currentUrl.origin}${currentUrl.pathname}${searchString ? "?" + searchString : ""}${currentUrl.hash}`;
};
const setPathname = (pathname) => {
  const currentUrl = new URL(window.location.href);
  currentUrl.pathname = pathname;
  return currentUrl.href;
};
const getParam = (name) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
};
const url = {
  setParam,
  setPathname,
  getParam
};

const PRESERVED_PARAMS = [
  "ta",
  "wl",
  "ref",
  "gid",
  "guid",
  "partner_tracking_id",
  "utm_campaign",
  "campaign",
  "staging_wl",
  "staging_api",
  "testing_api",
  "coupon_code",
  "dial_code",
  "first_name",
  "last_name",
  "email",
  "phone_number",
  "airline",
  "airline2",
  "flight_number",
  "flight_number2",
  "customer_special_instructions",
  "utm_source",
  "branch",
  "referral"
];
const addPreservedParams = (href, externalParams) => {
  const isServer = typeof window === "undefined";
  if (isServer && !externalParams) {
    return href;
  }
  try {
    const url = new URL(
      href,
      isServer ? "http://localhost" : window.location.origin
    );
    const currentParams = externalParams ?? new URLSearchParams(window.location.search);
    for (const param of PRESERVED_PARAMS) {
      const value = currentParams.get(param);
      if (value && !url.searchParams.has(param)) {
        url.searchParams.set(param, value);
      }
    }
    if (href.startsWith("http://") || href.startsWith("https://")) {
      return url.toString();
    }
    return url.pathname + url.search + url.hash;
  } catch {
    return href;
  }
};

export { addPreservedParams, hexToRgb, removeGeneratedIds, url };
